import styled from '@emotion/styled'

export const StyleSuccessAlertWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 12px;
`
export const Message = styled.p`
  color: ${(props: any) => props.theme.colors.text};
  letter-spacing: 0.5px;
`
export const ActionButtonContainer = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
  width: 100%;
  margin-top: 24px;
`
export const ActionButton = styled.button<{ variant?: string }>`
  flex: 1;
  border-radius: 8px;
  background-color: ${(props: any) =>
    props.variant === 'addLater' ? 'transparent' : props.theme.colors.primary};
  border: 1px solid ${(props: any) => props.theme.colors.primary};
  color: ${(props: any) =>
    props.variant === 'addLater'
      ? props.theme.colors.primary
      : props.theme.colors.white};
  height: 45px;
  cursor: pointer;
`

export const StyleRoomDetailTitle = styled.p`
  text-align: center;
  font-size: 20px;
  color: ${(props: any) => props.theme.colors.primary};
`
export const StyleRoomDetailMessage = styled.div`
  background-color: ${(props: any) => props.theme.colors.primaryLight};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props: any) => props.theme.colors.primary};
  border-radius: 5px;
  padding: 20px 10px;
  font-size: 14px;
`
